export default __webpack_public_path__ + "static/sign-d407d850aab06fc49e0b7560e25e0d78.png";